/**
 * Cart Mini Shipping Estimator
 * Fetches live Shopify shipping rates directly from the cart (no add/remove).
 * Canada-only. Re-initializes on cart:updated since drawer HTML is re-rendered.
 */
(function() {
  'use strict';

  var ZIP_KEY = 'scy_mc_ship_zip';
  var TIMEOUT_MS = 45000;

  var POSTAL_TO_PROVINCE = {
    A: 'NL', B: 'NS', C: 'PE', E: 'NB',
    G: 'QC', H: 'QC', J: 'QC',
    K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON',
    R: 'MB', S: 'SK', T: 'AB', V: 'BC',
    X: 'NT', Y: 'YT'
  };

  function zipToProvince(zip) {
    var first = zip.charAt(0).toUpperCase();
    return POSTAL_TO_PROVINCE[first] || null;
  }

  function init() {
    var wrap = document.getElementById('scy-mc-ship');
    if (!wrap) return;

    var input = document.getElementById('scy-mc-ship-zip');
    var btn = document.getElementById('scy-mc-ship-btn');
    var loadingEl = document.getElementById('scy-mc-ship-loading');
    var errorEl = document.getElementById('scy-mc-ship-error');
    var resultsEl = document.getElementById('scy-mc-ship-results');
    var langEl = document.getElementById('scy-mc-ship-lang');

    if (!input || !btn) return;

    var strings = {};
    if (langEl) {
      try { strings = JSON.parse(langEl.content.textContent); } catch(e) {}
    }

    // Restore saved postal code
    var savedZip = sessionStorage.getItem(ZIP_KEY);
    if (savedZip && !input.value) {
      input.value = savedZip;
    }

    var fetching = false;
    var progressTimers = [];

    btn.addEventListener('click', handleEstimate);
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); handleEstimate(); }
    });

    function handleEstimate() {
      if (fetching) return;

      var zip = (input.value || '').trim().toUpperCase();
      if (!zip) {
        showError(strings.error_empty || 'Please enter your postal code.');
        input.focus();
        return;
      }

      var province = zipToProvince(zip);
      if (!province) {
        showError(strings.error_generic || 'Unable to retrieve rates right now.');
        return;
      }

      // Save for persistence
      sessionStorage.setItem(ZIP_KEY, zip);

      fetching = true;
      clearResults();
      setLoading(true);

      // Analytics
      pushDL('mini_cart_shipping_estimate_requested', { zip_prefix: zip.substring(0, 3) });

      var controller = null;
      var timeoutId = null;

      if (window.AbortController) {
        controller = new AbortController();
        timeoutId = setTimeout(function() { controller.abort(); }, TIMEOUT_MS);
      }

      var fetchOpts = controller ? { signal: controller.signal } : {};
      var url = '/cart/shipping_rates.json?shipping_address[zip]='
        + encodeURIComponent(zip) + '&shipping_address[country]=CA'
        + '&shipping_address[province]=' + encodeURIComponent(province);

      fetch(url, fetchOpts)
        .then(function(res) {
          if (!res.ok) {
            return res.json().catch(function() { return {}; }).then(function(errData) {
              var msg = errData.errors || errData.message;
              if (msg && typeof msg === 'object') msg = Object.values(msg).flat().join(' ');
              throw new Error(msg || 'rate_fetch_failed');
            });
          }
          return res.json();
        })
        .then(function(data) {
          var rates = data.shipping_rates || [];
          renderRates(rates);
          pushDL('mini_cart_shipping_estimate_success', { rate_count: rates.length });
        })
        .catch(function(err) {
          if (err.name === 'AbortError') {
            showError(strings.error_timeout || 'Carriers took too long to respond.');
            pushDL('mini_cart_shipping_estimate_failure', { error_type: 'timeout' });
          } else {
            showError(err.message || strings.error_generic || 'Unable to retrieve rates right now.');
            pushDL('mini_cart_shipping_estimate_failure', { error_type: err.message || 'unknown' });
          }
        })
        .finally(function() {
          fetching = false;
          setLoading(false);
          if (timeoutId) clearTimeout(timeoutId);
        });
    }

    function renderRates(rates) {
      if (!rates || rates.length === 0) {
        resultsEl.innerHTML = '<p class="scy-mc-ship-heading">'
          + escHtml(strings.no_rates || 'No shipping options found for this postal code.') + '</p>';
        resultsEl.style.display = '';
        return;
      }

      rates.sort(function(a, b) { return parseFloat(a.price) - parseFloat(b.price); });

      var html = '<p class="scy-mc-ship-heading">'
        + escHtml(strings.heading || 'Available shipping options:') + '</p>';
      html += '<ul class="scy-mc-ship-rates">';

      for (var i = 0; i < rates.length; i++) {
        var rate = rates[i];
        var price = parseFloat(rate.price);
        var priceStr = price === 0
          ? (strings.free || 'Free')
          : '$' + price.toFixed(2) + ' CAD';

        html += '<li class="scy-mc-ship-rate">';
        html += '<span class="scy-mc-ship-rate-name">' + escHtml(rate.name) + '</span>';
        html += '<span class="scy-mc-ship-rate-price">' + priceStr + '</span>';

        if (rate.delivery_range && rate.delivery_range.length === 2) {
          var delivStr = formatDelivery(rate.delivery_range, !!strings._fr);
          if (delivStr) {
            html += '<span class="scy-mc-ship-rate-delivery">' + escHtml(delivStr) + '</span>';
          }
        }
        html += '</li>';
      }
      html += '</ul>';
      html += '<p class="scy-mc-ship-checkout-note">\u2713 '
        + escHtml(strings.checkout_note || 'Same rates at checkout \u2014 no surprises') + '</p>';

      resultsEl.innerHTML = html;
      resultsEl.style.display = '';
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = '';
    }

    function clearResults() {
      resultsEl.innerHTML = '';
      resultsEl.style.display = 'none';
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    function setLoading(on) {
      btn.disabled = on;
      var btnText = btn.querySelector('[data-mc-ship-btn-text]');
      var spinner = btn.querySelector('[data-mc-ship-spinner]');
      if (btnText) btnText.style.display = on ? 'none' : '';
      if (spinner) spinner.style.display = on ? '' : 'none';

      if (on) {
        startProgressiveMessages();
      } else {
        stopProgressiveMessages();
      }
    }

    function startProgressiveMessages() {
      var msgs = [
        { delay: 0, text: strings.loading_1 || 'Contacting carriers\u2026' },
        { delay: 8000, text: strings.loading_2 || 'Calculating rates\u2026' },
        { delay: 18000, text: strings.loading_3 || 'Still working\u2026' }
      ];

      loadingEl.textContent = msgs[0].text;
      loadingEl.style.display = '';

      for (var i = 1; i < msgs.length; i++) {
        (function(idx) {
          progressTimers.push(setTimeout(function() {
            loadingEl.textContent = msgs[idx].text;
          }, msgs[idx].delay));
        })(i);
      }
    }

    function stopProgressiveMessages() {
      for (var i = 0; i < progressTimers.length; i++) {
        clearTimeout(progressTimers[i]);
      }
      progressTimers = [];
      loadingEl.textContent = '';
      loadingEl.style.display = 'none';
    }
  }

  function pushDL(event, extra) {
    if (!window.dataLayer) return;
    var obj = { event: event, source_market: window.T4Sconfigs && window.T4Sconfigs.sourceMarket };
    if (extra) {
      for (var k in extra) { if (extra.hasOwnProperty(k)) obj[k] = extra[k]; }
    }
    window.dataLayer.push(obj);
  }

  var MONTHS_EN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var MONTHS_FR = ['janv.','f\u00e9vr.','mars','avr.','mai','juin','juil.','ao\u00fbt','sept.','oct.','nov.','d\u00e9c.'];

  function formatDelivery(range, isFr) {
    var months = isFr ? MONTHS_FR : MONTHS_EN;
    var d1 = new Date(range[0] + 'T00:00:00');
    var d2 = new Date(range[1] + 'T00:00:00');
    if (isNaN(d1.getTime())) return '';
    var m1 = months[d1.getMonth()], day1 = d1.getDate();
    var prefix = isFr ? 'Livraison pr\u00e9vue' : 'Arrives';
    if (isNaN(d2.getTime()) || d1.getTime() === d2.getTime()) {
      return prefix + ' ' + m1 + ' ' + day1;
    }
    var m2 = months[d2.getMonth()], day2 = d2.getDate();
    if (m1 === m2) {
      return prefix + ' ' + m1 + ' ' + day1 + '\u2013' + day2;
    }
    return prefix + ' ' + m1 + ' ' + day1 + ' \u2013 ' + m2 + ' ' + day2;
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after cart section re-render (drawer HTML is replaced)
  document.addEventListener('cart:updated', function() {
    setTimeout(init, 50);
  });
})();
